import { render, staticRenderFns } from "./Introductories.vue?vue&type=template&id=44c2f6cd"
import script from "./Introductories.vue?vue&type=script&lang=js"
export * from "./Introductories.vue?vue&type=script&lang=js"
import style0 from "./Introductories.vue?vue&type=style&index=0&id=44c2f6cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports